import type { AssetWorkflowOptions } from '../../types';

export const addCarrierScheduleWorkflow: AssetWorkflowOptions = {
  workflowKey: 'addCarrierScheduleWorkflow',
  workflowType: 'editAssetWorkflow',
  assetType: 'schedule',
  shipiumOnly: true,
  overrideSave: 'addCarrierSchedule',
  workflowConditionalMatcher: [
    {
      assetType: 'schedule',
      schema: {
        type: 'array',
        minItems: 1,
      },
    },
    {
      assetType: 'origin',
      schema: {
        type: 'array',
        minItems: 1,
      },
    },
  ],
  workflowIndex: 1,
  workflowName: 'Add a Carrier Schedule details',
  workflowDescription: `Add carrier specific overrides to your origin schedules. If you need to specify a carrier or method specfic last pull time or you know that carrier doesn't ship on particular day, you can set that here`,
  workflowStepOptions: [
    {
      workflowStepKey: 'scheduleEntryFrom',
      workflowStepNavigationName: 'Schedule Entry',
      workflowComponent: {
        workflowComponentType: 'scheduleEntrySelect',
        prompt: 'Which entries should this carrier schedule apply to?',
        allowMultiple: true,
        description: ``,
        defaultValue: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'scheduleEntryFrom',
      },
      calculatedComponentProps: {
        scheduleId: {
          property: 'scheduleId',
          type: 'asset',
        },
      },
    },
    {
      workflowStepKey: 'carrier',
      workflowStepNavigationName: 'Carrier',
      workflowComponent: {
        workflowComponentType: 'carrierServiceMethodEntry',
        prompt: 'Which carrier does this schedule apply to?',
        hideCarriers: false,
        hideServiceMethods: true,
        singleSelect: true,
        description: ``,
        defaultValue: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'carrier',
      },
    },
    {
      workflowStepKey: 'allMethods',
      workflowStepNavigationName: 'Applies to all Methods?',
      workflowComponent: {
        workflowComponentType: 'singleSelect',
        prompt: 'Does this schedule apply to all methods of this carrier?',
        description: ``,
        defaultValue: '',
        help: '',
        options: [
          {
            optionValue: true,
            optionText: 'Yes, applies to all methods',
          },
          {
            optionValue: false,
            optionText: 'No, only applies to specific methods',
          },
        ],
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
    {
      workflowStepKey: 'serviceMethods',
      workflowStepNavigationName: 'Service Methods',
      workflowComponent: {
        workflowComponentType: 'carrierServiceMethodEntry',
        prompt: 'Which service method does this schedule apply to?',
        hideCarriers: true,
        description: ``,
        defaultValue: '',
        help: '',
      },
      calculatedComponentProps: {
        allowedCarriers: {
          property: 'carrier',
          type: 'workflowStep',
          transformFn: (p) => [p],
        },
      },
      workflowStepConditionalMatcher: [{ workflowStepKey: 'allMethods', schema: { type: 'boolean', const: false } }],
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'serviceMethods',
      },
    },
    {
      workflowStepKey: 'cutoffTimesEntry',
      workflowStepNavigationName: 'Cutoff Times',
      workflowComponent: {
        workflowComponentType: 'cutoffTimesEntry',
        prompt: '',
        hideCarriers: true,
        description: ``,
        defaultValue: '',
        help: `Specify pick up times for this carrier/set of methods.  If you want to ship on these days you must specify a cutoff time. `,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'cutoffTimes',
      },
    },
    {
      workflowStepKey: 'cutoffExpcetions',
      workflowStepNavigationName: 'Cutoff Exceptions',
      workflowComponent: {
        workflowComponentType: 'cutoffExceptionEntry',
        prompt: '',
        hideCarriers: true,
        description: ``,
        defaultValue: '',
        help: 'If you know there are specific dates where your carrier pick up times will change you can update the schedule to reflect that here',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'cutoffExceptions',
      },
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Add Carrier Schedule Summary',
        description: 'The Carrier Schedule will be created.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
